// Place search with Photon (komoot), through the Worker for caching and fair-use protection.

import type { LngLat } from '../lib/geo';
import type { GeocoderSource, Place } from './types';

interface PhotonFeature {
  geometry: { coordinates: LngLat };
  properties: Record<string, string | undefined>;
}

export class PhotonGeocoder implements GeocoderSource {
  readonly id = 'photon';
  readonly attribution = 'Search: <a href="https://photon.komoot.io/">Photon</a> / © OpenStreetMap contributors';
  constructor(private apiBase: string) {}

  async search(q: string, near?: LngLat): Promise<Place[]> {
    let u = `${this.apiBase}/geocode?q=${encodeURIComponent(q)}`;
    if (near) u += `&lat=${near[1].toFixed(2)}&lon=${near[0].toFixed(2)}`;
    const res = await fetch(u);
    if (!res.ok) throw new Error(`Search unavailable (${res.status})`);
    const j = (await res.json()) as { features: PhotonFeature[] };
    return j.features.map((f) => {
      const p = f.properties;
      return {
        name: p.name ?? p.street ?? '?',
        detail: [p.osm_value, p.city, p.state, p.country].filter(Boolean).join(', '),
        at: f.geometry.coordinates,
      };
    });
  }
}
